import { BASE_API_URL } from "../../config/Api";
import { ADD_HOLIDAY_DATA, HOLIDAY_LIST, LOGIN, LOGOUT, REQ_USER } from "./ActionType";

export const login = (data) => async (dispatch) => {
  try {
    const res = await fetch(`${BASE_API_URL}/authenticate`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    const resData = await res.json();
    if (resData.token) localStorage.setItem("token", resData.token);

    dispatch({ type: LOGIN, payload: resData });
    return resData;
  } catch (error) {}
};

export const currentUser = (token) => async (dispatch) => {
  try {
    const res = await fetch(`${BASE_API_URL}/getUserProfile`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    const resData = await res.json();

    if (resData.loginId) localStorage.setItem("loginId", resData.loginId);
    if (resData.role) localStorage.setItem("role", resData.role);
    dispatch({ type: REQ_USER, payload: resData });
  } catch (error) {}
};

export const logoutAction = () => async (dispatch) => {
  localStorage.clear();
  dispatch({ type: LOGOUT, payload: null });
  dispatch({ type: REQ_USER, payload: null });
};

export const getHolidayList = (token) => async (dispatch) => {
  try {
    const res = await fetch(`${BASE_API_URL}/holidayList`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    const resData = await res.json();
    dispatch({ type: HOLIDAY_LIST, payload: resData });
  } catch (error) {}
};

export const holidayListupdate = (data, token) => async (dispatch) => {
    try {
        const res = await fetch(`${BASE_API_URL}/holidayListupdate`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(data),
        });
        const resData = await res.json();

        if (res.ok && resData.statusCode === "00") {
            dispatch({ type: ADD_HOLIDAY_DATA, payload: resData });
            return resData;
        } else {
            return {
                success: false,
                error: resData.statusDesc || "An unknown error occurred",
            };
        }
    } catch (error) {
        console.error("Error occurred in holidayListupdate:", error);
    }
}
